import { render } from "./LoginFormCode.vue?vue&type=template&id=b10dcf44&scoped=true"
import script from "./LoginFormCode.vue?vue&type=script&lang=js"
export * from "./LoginFormCode.vue?vue&type=script&lang=js"

import "./LoginFormCode.vue?vue&type=style&index=0&id=b10dcf44&lang=scss&scoped=true"

import exportComponent from "/var/www/fgc-dev-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b10dcf44"]])

export default __exports__